<template>
<div>
  <div class="wistia_embed wistia_async_r8b4yfd59x">
    &nbsp;
  </div>

  <div
    id="elearning-choices"
    class="tbk-vid-embed"
  >
    <a
      id="elearning-positive"
      class="embedded_video"
      href="#wistia_pyqqfsbgs2?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="elearning-negative"
      class="embedded_video"
      href="#wistia_a59qk752m6?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </div>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    this.tbk.loadCrossTime('r8b', 25, this.showSelect)

    if (this.tbk.isMobile()) {
      _wq.push({
        pyq: this.tbk.autoPlay,
        a59: this.tbk.autoPlay
      })
    }
  },

  methods: {
    showSelect() {
      $('.tbk-vid-embed').show()
      this.tbk.hideMobileControls()
    }
  }
}
</script>

<style scoped lang="sass">
#elearning-choices
  display: none
  a
    text-decoration: none
#elearning-negative
  position: absolute
  top: calc(100% * (185 / 360))
  left: calc(100% * (170 / 640))
  width: calc(100% * (100 / 640))
  height: calc(100% * (100 / 360))
#elearning-positive
  position: absolute
  top: calc(100% * (185 / 360))
  left: calc(100% * (358 / 640))
  width: calc(100% * (100 / 640))
  height: calc(100% * (100 / 360))
</style>
